import { DragDndItemsType } from "@/common/type/type";
import { WidgetDataType } from "@/pages/dashboard/type";

export const handleDelete = (
  boxId: number,
  machineId: number,
  dragAreaItems: DragDndItemsType,
  setTotalWidgets: React.Dispatch<React.SetStateAction<WidgetDataType[]>>
) => {
  const itemToDelete = dragAreaItems.find((item) => item.id === boxId);
  let position = 1;

  if (itemToDelete) {
    const { type, sortId } = itemToDelete;

    setTotalWidgets((prev) =>
      prev.map((widget) => {
        if (widget.machineId === machineId) {
          let updatedWidget = { ...widget };

          if (type === 1 || type === 2) {
            const updatedDataWidgets = widget.dataWidgets
              .filter((data) => data.sortId !== sortId)
              .map((data) => ({
                ...data,
                position: position++,
              }));

            const updatedTrendWidgets = widget.trendWidgets
              .filter((trend) => trend.sortId !== sortId)
              .map((trend) => ({
                ...trend,
                position: position++,
              }));

            updatedWidget = {
              ...updatedWidget,
              dataWidgets: updatedDataWidgets,
              trendWidgets: updatedTrendWidgets,
            };
          }

          return updatedWidget;
        }
        return widget;
      })
    );

    const newDragAreaItems = dragAreaItems
      .filter((item) => item.id !== boxId)
      .map((item, index) => ({
        ...item,
        position: index + 1,
      }));

    dragAreaItems.length = 0;
    dragAreaItems.push(...newDragAreaItems);
  }
};
